/* Cart add-on upsell — populates EVERY [data-cart-upsell] container with recommended
   add-ons + overstock clearance (mini-cart panel AND /cart page).
   Idempotent: snippets/ajax-cart.liquid is rendered 3x per page, so this script is
   included 3x; the guard below ensures the module + click listener bind only once.
   Two-JS-systems note: only READS resulting cart state; never touches PDP variant radios. */
(function () {
  window.PXUTheme = window.PXUTheme || {};
  if (window.PXUTheme.jsCartUpsell) { return; } // already loaded — do not re-bind

  var SECTION_ID = 'cart-upsell';
  var SHOW = 6; // rows visible per container
  var POOL = 8; // rows fetched per intent

  function containers() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-upsell]'));
  }
  function recommendationsBase() {
    var w = document.querySelector('[data-cart-upsell]');
    return (w && w.getAttribute('data-recommendations-url')) || '/recommendations/products';
  }

  window.PXUTheme.jsCartUpsell = {
    cache: {}, // seed(product_id) -> deduped recommendation rows (detached templates).
    // Page-load scoped: a login state change always navigates (fresh page → fresh cache),
    // so the server-rendered member/guest rows here never go stale within a session.

    // Every add fires TWO refreshes ~750ms apart: updateView() calls the bare
    // one when its section render lands, and the PDP add path calls the SEEDED
    // one. Both rebuild 21 nodes in EACH of 3 containers — 63 node operations
    // and 18 images, twice, for markup that is visibility:hidden in all three.
    // Traced 2026-08-26: that is the Layerize + ~100 UpdateLayer + DroppedFrame
    // behind the flicker, and the second rebuild lands mid-scroll.
    // _gen makes only the LATEST refresh paint, so the pair collapses to one.
    _gen: 0,
    // Wall-clock until which painting is held off, set by addedToCart while its
    // scroll animation runs. The strip is hidden, so a late paint costs nothing;
    // dropping frames during a 1s scroll costs the shopper a visible stutter.
    _holdUntil: 0,

    // Seed handed over by the PDP add path instead of it calling refresh() a
    // second time — see the _pendingSeed note in z__jsAjaxCart.js addToCart.
    _pendingSeed: null,

    refresh: function (explicitSeed) {
      var self = this;
      if (!containers().length) { return; }
      if (explicitSeed === undefined && this._pendingSeed) {
        explicitSeed = this._pendingSeed;
        this._pendingSeed = null;
      }
      this._gen++;
      var gen = this._gen;
      var cartUrl = (window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || '/cart';
      fetch(cartUrl + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var cartIds = items.map(function (i) { return i.product_id; });
          // Seed off the NEWEST real line. `cart.items` is newest-FIRST (Shopify
          // prepends new lines — verified live), so that's items[0], not the tail.
          // Skip the auto-added service lines — the return-cover line (marked
          // `_returncover`, or legacy `_freereturn` on carts created before this
          // became opt-in) and the packing-preference line: both are added AFTER the
          // product that triggered them, so one of them is usually items[0] itself,
          // and recommending off either is useless. A services-only cart can't happen;
          // if it ever did, falling through to the browsing seed below is better.
          var seedItems = items.filter(function (i) {
            if (i.properties && (i.properties._returncover || i.properties._freereturn)) { return false; }
            return i.product_type !== 'Packaging Preference';
          });
          var cartSeed = explicitSeed || (seedItems.length ? seedItems[0].product_id : null);
          if (cartSeed) {
            self.fromCart = true;
            if (self.cache[cartSeed]) { self.paintAll(self.cache[cartSeed], cartIds, gen); return; }
            self.fetchUpsells(cartSeed, cartIds, gen);
            return;
          }
          // Empty cart: fall back to the browsing seed (last-added -> last-viewed).
          self.fromCart = false;
          var browseSeed = window.HillmalayaRecentlyViewed ? window.HillmalayaRecentlyViewed.resolveSeed() : null;
          if (browseSeed) {
            if (self.cache[browseSeed]) { self.paintAll(self.cache[browseSeed], cartIds, gen); return; }
            self.fetchUpsells(browseSeed, cartIds, gen);
            return;
          }
          // No seed at all: paint the clearance pool only (orderFor returns clearance rows for []).
          self.paintAll([], cartIds, gen);
        })
        .catch(function () { /* fail silent */ });
    },

    fetchUpsells: function (seed, cartIds, gen) {
      var self = this;
      this.fetchIntent(seed, 'complementary')
        .then(function (rows) {
          rows = self.dedupe(rows, cartIds, []);
          if (rows.length >= SHOW) { self.cacheAndPaint(seed, rows, cartIds, gen); return; }
          self.fetchIntent(seed, 'related').then(function (more) {
            var seen = rows.map(function (n) { return n.getAttribute('data-product-id'); });
            more = self.dedupe(more, cartIds, seen);
            self.cacheAndPaint(seed, rows.concat(more), cartIds, gen);
          }).catch(function () { self.cacheAndPaint(seed, rows, cartIds, gen); });
        })
        .catch(function () { self.cacheAndPaint(seed, [], cartIds, gen); });
    },

    fetchIntent: function (seed, intent) {
      var url = recommendationsBase() +
        '?section_id=' + SECTION_ID +
        '&product_id=' + encodeURIComponent(seed) +
        '&intent=' + intent +
        '&limit=' + POOL;
      return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('[data-upsell-row]'));
        });
    },

    dedupe: function (rows, cartIds, seenIds) {
      var out = [], seen = {};
      (seenIds || []).forEach(function (id) { seen[String(id)] = true; });
      (cartIds || []).forEach(function (id) { seen[String(id)] = true; });
      rows.forEach(function (node) {
        var id = node.getAttribute('data-product-id');
        if (!seen[id]) { seen[id] = true; out.push(node); }
      });
      return out;
    },

    // Build ordered CLONES for one container: recs are shared, so clone per container.
    // contextual overstock -> general clearance -> complementary.
    orderFor: function (container, recRows, cartIds) {
      var clones = recRows.map(function (n) { return n.cloneNode(true); });
      clones = this.dedupe(clones, cartIds, []); // drop any now-in-cart
      var over = [], normal = [];
      clones.forEach(function (n) {
        if (n.hasAttribute('data-overstock')) { over.push(n); } else { normal.push(n); }
      });
      var chosenIds = over.map(function (n) { return n.getAttribute('data-product-id'); });
      var clearance = this.dedupe(this.clearanceRows(container), cartIds, chosenIds);
      return over.concat(clearance).concat(normal);
    },

    clearanceRows: function (container) {
      var box = container.querySelector('[data-cart-upsell-clearance]');
      if (!box) { return []; }
      return Array.prototype.slice.call(box.querySelectorAll('[data-upsell-row]'))
        .map(function (n) { return n.cloneNode(true); });
    },

    cacheAndPaint: function (seed, recRows, cartIds, gen) {
      this.cache[seed] = recRows;
      this.paintAll(recRows, cartIds, gen);
    },

    paintAll: function (recRows, cartIds, gen) {
      var self = this;
      // A superseded refresh must not paint — its rows are already stale and the
      // rebuild is pure cost.
      if (gen !== undefined && gen !== this._gen) { return; }
      var wait = this._holdUntil - Date.now();
      if (wait > 0) {
        window.setTimeout(function () { self.paintAll(recRows, cartIds, gen); }, wait + 20);
        return;
      }
      containers().forEach(function (c) { self.paintContainer(c, recRows, cartIds); });
      if (window.PXUTheme.currencyConverter) { window.PXUTheme.currencyConverter.convertCurrencies(); }
    },

    paintContainer: function (container, recRows, cartIds) {
      var rowsEl = container.querySelector('[data-cart-upsell-rows]');
      if (!rowsEl) { return; }
      rowsEl.classList.remove('cart-upsell__rows--loading'); // reveal real rows (drops the /cart skeleton)
      this.setEyebrow(container);
      var ordered = this.orderFor(container, recRows, cartIds);
      rowsEl.innerHTML = '';
      container._upsellPool = ordered;
      var shown = container._upsellPool.splice(0, SHOW);
      shown.forEach(function (node) { rowsEl.appendChild(node); });
      container.hidden = shown.length === 0;
    },

    setEyebrow: function (container) {
      var eb = container.querySelector('.cart-upsell__eyebrow');
      if (!eb) { return; }
      var attr = this.fromCart ? 'data-eyebrow-cart' : 'data-eyebrow-empty';
      var txt = eb.getAttribute(attr);
      if (txt) { eb.textContent = txt; }
    },

    clearAll: function () {
      containers().forEach(function (container) {
        var rowsEl = container.querySelector('[data-cart-upsell-rows]');
        if (rowsEl) { rowsEl.innerHTML = ''; }
        container.hidden = true;
        container._upsellPool = [];
      });
    },

    addVariant: function (btn) {
      var self = this;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) { return; }
      // `Order Type 訂單類別` is set by assets/utilities.js from the PDP form only, and
      // nothing back-fills it at cart render, so a line added here would reach the order
      // with none. That
      // silently skips the thank-you consent pop-up, which fires on
      // `Order Type contains "Final Sale"` — leaving a shopper unwarned about a
      // non-returnable clearance item. Liquid computes the value per variant in
      // snippets/order-type-value.liquid; this only carries it.
      var orderType = btn.getAttribute('data-order-type');
      var container = btn.closest('[data-cart-upsell]');
      var row = btn.closest('[data-upsell-row]');
      var isPanel = !!btn.closest('#theme-ajax-cart'); // mini-cart panel vs /cart page
      var cartUrl = (window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || '/cart';
      btn.disabled = true;
      fetch(cartUrl + '/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
        body: 'id=' + encodeURIComponent(variantId) + '&quantity=1' +
          // Encode the whole key: it contains a space and CJK characters.
          (orderType ? '&' + encodeURIComponent('properties[Order Type 訂單類別]') + '=' + encodeURIComponent(orderType) : '')
      })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
        .then(function () {
          btn.classList.add('is-added');
          btn.textContent = '✓';
          if (isPanel) {
            if (window.PXUTheme.jsAjaxCart) { window.PXUTheme.jsAjaxCart.updateView(); }
            setTimeout(function () { self.consumeRow(container, row); }, 600);
          } else {
            // /cart page uses form/reload semantics — reflect the new line + totals.
            setTimeout(function () { window.location.reload(); }, 350);
          }
        })
        .catch(function () { btn.disabled = false; });
    },

    consumeRow: function (container, row) {
      if (!container) { return; }
      var rowsEl = container.querySelector('[data-cart-upsell-rows]');
      if (row && row.parentNode) { row.parentNode.removeChild(row); }
      var pool = container._upsellPool || [];
      if (rowsEl && pool.length) { rowsEl.appendChild(pool.shift()); }
      if (rowsEl && rowsEl.children.length === 0) { container.hidden = true; }
      if (window.PXUTheme.currencyConverter) { window.PXUTheme.currencyConverter.convertCurrencies(); }
    }
  };

  // Delegated click — bound ONCE (the module guard above prevents re-binding on re-include).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cart-upsell-add]') : null;
    if (btn) { e.preventDefault(); window.PXUTheme.jsCartUpsell.addVariant(btn); }
  });

  // /cart page: the strip is always visible (no panel-open trigger). Populate on load.
  function pageInit() {
    if (document.querySelector('[data-cart-upsell-context="page"]')) {
      window.PXUTheme.jsCartUpsell.refresh();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pageInit);
  } else {
    pageInit();
  }
})();
